<div class="wrapper">
    <section id="banner-planos" class="banner-container hero is-medium"
             style="background:url(https://www.viagensmontreal.com/design/2021/banner_site/banner_destino.jpg) no-repeat center bottom; padding-top: 25px;">
        <div class="hero-body bg-hoteis-destinos">
            <div class="container">
                <div class="area-breadcrumb">
                    <nav class="breadcrumb">
                        <ul>
                            <li><a href="/"><strong>Home</strong></a></li>
                            <span><i class="fas fa-chevron-right"></i></span>
                            <li>Planos</li>
                        </ul>
                    </nav>
                </div>
                <div class="espacamento-esquerda">
                    <h1 class="title has-text-white">Nossos Planos</h1>
                </div>
            </div>
        </div>
        <small class="has-text-white" style="text-align: end; padding-right: 0.8em">Rio de Janeiro - RJ</small>
    </section>
    <section id="planos">
        <div class="container is-fluid">
            <div class="columns">
                <div class="column is-12">
                    <h1>Planos</h1>
                    <p>
                        Aqui é simples: os planos foram divididos por hotéis. Você escolhe o que mais combina com você e pronto. <br>
                        Além disso, a <strong>taxa de adesão é sempre grátis*</strong> e o melhor: você não precisa mais se preocupar com o complemento e nem o regime de alimentação. É isso mesmo! Os<br>
                        valores de taxas adicionais como períodos de alta temporada, complemento de diárias e regime de alimentação* dos hotéis já estão inclusos no valor do seu plano.
                    </p>

                </div>
            </div>
            <div class="itens-planos" *ngIf="planos.length > 0">
                <div class="tile is-ancestor" *ngIf="planos1Size > 0">
                    <div class="tile is-vertical is-9">
                        <div class="tile">
                            <div class="tile is-parent is-vertical" *ngFor="let plano of planos1">
                                <article class="tile is-child notification is-primary"
                                         [style.backgroundImage]="'url('+ plano.images[0] +')'"
                                         style="background-size: cover;">
                                    <a><div class="img-overlay img-overlay-planos"></div></a>
                                </article>
                                <div class="footer-planos">
                                    <p class="title-planos">{{plano.descricao}} </p>
                                    <p class="subtitle-planos"> {{plano.qtdDiarias[0].valor | currency: 'BRL': 'symbol' : '1.2-2'}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tile is-ancestor" *ngIf="planos2Size > 0">
                    <div class="tile is-vertical is-99">
                        <div class="tile">
                            <div class="tile is-parent is-vertical" *ngFor="let plano of planos2">
                                <article class="tile is-child notification is-primary"
                                         [style.backgroundImage]="'url('+ plano.images[0] +')'"
                                         style="background-size: cover;">
                                    <a><div class="img-overlay img-overlay-planos"></div></a>
                                </article>
                                <div class="footer-planos">
                                    <p class="title-planos">{{plano.descricao}} </p>
                                    <p class="subtitle-planos"> {{plano.qtdDiarias[0].valor | currency: 'BRL': 'symbol' : '1.2-2'}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <app-footer></app-footer>
</div>
